export default __webpack_public_path__ + "static/media/brand_logo.8a7bfdd0.png";